const FADE_DISTANCE = 20;
class Star extends Phaser.Sprite {
  constructor(game, a, scale) {
    super(game);

    this.size = scale * 0.5 + Math.random() * scale * 0.5;
    this.costume = this.game.make.image(0, 0, 'ui_character_icons', 'star');
    this.costume.anchor.set(0.5);
    this.costume.angle = Math.random() * 360;
    this.costume.scale.set(this.size);

    this.shadow = this.game.make.image(0, 7, 'ui_character_icons', 'star_shadow');
    this.shadow.anchor.set(0.5);
    this.shadow.angle = this.costume.angle;
    this.shadow.scale.set(this.size);

    this.addChild(this.shadow);
    this.addChild(this.costume);

    const randomSpeed = 30 + Math.random() * 30;
    this.vx = randomSpeed * Math.cos(a);
    this.vy = -randomSpeed * Math.sin(a);
  }

  update() {
    const step = this.game.time.elapsedMS / 1000;
    this.x += this.vx * step;
    this.y += this.vy * step;
    this.costume.angle += 5;
    this.shadow.angle += 5;

    const distance = Phaser.Math.distance(0, 0, this.x, this.y);

    this.costume.scale.set(this.costume.scale.x * 0.96, this.costume.scale.y * 0.96);
    this.shadow.scale.set(this.shadow.scale.x * 0.96, this.shadow.scale.y * 0.96);

    if (distance > FADE_DISTANCE && this.alpha > 0.1) {
      this.alpha += (0 - this.alpha) * 4 * step;
      this.vx += (0 - this.vx) * 2 * step;
      this.vy += (0 - this.vy) * 2 * step;
    } else if (distance > FADE_DISTANCE) {
      this.destroy(true);
    }
  }
}

export default class StarBurst extends Phaser.Sprite {
  constructor(game, r1 = 40, r2 = 65, scale = 0.6) {
    super(game, 0, 0);

    for (let i = 0; i < 15; i++) {
      const a = Math.random() * 2 * Math.PI;
      const star = new Star(game, a, scale);
      const r = r1 + Math.random() * (r2 - r1);

      star.x = r * Math.cos(a);
      star.y = -r * Math.sin(a);

      this.addChild(star);
    }
  }

  update() {
    if (this.children.length === 0) {
      this.destroy();
    } else {
      for (const star of this.children) {
        star.update();
      }
    }
  }

  destroy(destroyChildren = true) {
    for (let star of this.children) {
      star.destroy(true);
      star = null;
    }
    super.destroy(destroyChildren);
  }
}
